module.exports = __webpack_public_path__ + "static/media/06.66042113.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/06.png
// module id = 177
// module chunks = 0